// extracted by mini-css-extract-plugin
export default {"r_l":"_599fdd4be2 f1fb8c8485","t":"f080089083"};